<template>
  <div class="font-bold">
    <tool-bar title="Contact us"></tool-bar>
    <div class="font-16 color-14171B padding-20">
      If you have any questions, please contact us through the following ways.
    </div>
    <div class="padding-h-15">
      <div class="card-bg padding-20 radius-25 margin-b-15">
        <div class="font-16 color-888F99 margin-b-14">Whatsapp</div>
        <div class="font-21 color-14171B">{{ dicInfo.whatsapp }}</div>
      </div>
      <div class="card-bg padding-20 radius-25 margin-b-15">
        <div class="font-16 color-888F99 margin-b-14">Support Email</div>
        <div class="font-21 color-14171B">{{ dicInfo.feedbackEmail }}</div>
      </div>
      <div class="card-bg padding-20 radius-25 margin-b-15">
        <div class="font-16 color-888F99 margin-b-14">Support Hotline</div>
        <div
          class="font-21 color-14171B margin-b-14"
          v-for="(p, index) of c_phones"
          :key="index"
        >
          {{ p }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contact_us",
  data() {
    return {
      dicInfo: {},
    };
  },
  computed: {
    c_phones() {
      let phones = this.dicInfo.customerServicePhone
        ? this.dicInfo.customerServicePhone.split(",")
        : [];
      return phones;
    },
  },
  mounted() {
    this.$request
      .findDictInfo()
      .then((res) => {
        this.dicInfo = res;
      })
      .catch(() => {});
  },
};
</script>
<style scoped>
.card-bg {
  background: linear-gradient(
    0deg,
    rgba(16, 147, 255, 0.1) 0%,
    rgba(105, 187, 255, 0.1) 100%
  );
}
</style>